import useSWR from "swr";

import { useLocalStorageWatcher } from "../../../../lib/localStorage/hooks/useLocalStorageWatcher";
import whatsNewService from "../../../../services/whatsNew.service";

/**
 * Checks if there are any new posts in whats new that haven't been read. This is done by comparing the
 * number of files on the server by API call with the number last viewed stored in local storage. If the
 * whats new section has never been viewed, it will always return false.
 */
const useAreThereWhatsNewUpdates = () => {
    const { data } = useSWR(whatsNewService.GET_WHATS_NEW_COUNT_SWR_KEY, whatsNewService.getWhatsNewCount, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshWhenHidden: false,
        refreshWhenOffline: false,
        revalidateIfStale: false,
        refreshInterval: 1000 * 60 * 60, // 1 hour,
    });

    const localStorageCount = useLocalStorageWatcher("whats_new_count");

    const localStorageCountAsNumber = Number(localStorageCount || undefined);
    const apiWhatsNewCount = Number(data?.data?.count);

    if (Number.isNaN(localStorageCountAsNumber) || Number.isNaN(apiWhatsNewCount)) {
        return true;
    }

    return apiWhatsNewCount !== localStorageCountAsNumber;
};

export default useAreThereWhatsNewUpdates;
